import type { FloatingIconConfig } from './auth-layout.interface'

export const AUTH_FLOATING_ICON_LIST: FloatingIconConfig[] = [
  {
    src: '/assets/tools/semr.svg',
    alt: 'SEMrush',
    top: '6%',
    left: '58%',
    size: 180,
    parallaxFactor: 15,
    opacity: 0.15,
  },
  {
    src: '/assets/tools/ahrefs.svg',
    alt: 'Ahrefs',
    top: '28%',
    left: '82%',
    size: 100,
    parallaxFactor: 22,
    opacity: 0.2,
  },
  {
    src: '/assets/tools/googleanalytics.svg',
    alt: 'Google Analytics',
    top: '56%',
    left: '-5%',
    size: 172,
    parallaxFactor: 10,
    opacity: 0.1,
  },
  {
    src: '/assets/tools/googlesearchconsole.svg',
    alt: 'Google Search Console',
    top: '62%',
    left: '86%',
    size: 40,
    parallaxFactor: 18,
    opacity: 0.2,
  },
  {
    src: '/assets/tools/gemini.svg',
    alt: 'Gemini',
    top: '14%',
    left: '8%',
    size: 62,
    parallaxFactor: 30,
    opacity: 0.2,
  },
  {
    src: '/assets/tools/surfer.svg',
    alt: 'Surfer SEO',
    top: '80%',
    left: '72%',
    size: 68,
    parallaxFactor: 25,
    opacity: 0.1,
  },
  {
    src: '/assets/tools/claude.svg',
    alt: 'Claude',
    top: '90%',
    left: '22%',
    size: 84,
    parallaxFactor: 16,
    opacity: 0.15,
  },
]
